import { Funcionario } from 'src/app/core/funcionario';
import { AcaoExecutada } from "./acao-executada";
import { Atividade } from './atividade';
import { GrupoAcoesSimples } from './grupo-acoes-simples';
import { MateriaisAcao } from './materiais-acao';
import { MetaAcao } from "./meta-acao";
import { UsuarioSistema } from './usuario-sistema';

export class Acoes {
    id: number;

    dataFim: Date;
    dataInicio: Date;
    dataPrevisaoFim: Date;
    dataPrevisaoInicio: Date;
    dataAprovaAcao: Date;

    descricao: string;
    descricaoObjetivoAcao: string;
    descricaoMetodologiaAcao: string;
    descricaoAvaliacaoAcao: string;
    descricaoOcorrenciaAcao: string;

    oficina: Atividade;

    funcionarioPlanejamentoAcao: Funcionario;
    funcionarioAprovaAcao: Funcionario;
    funcionarioExecutaAcao: Funcionario;
    usuarioAlteracao: number;

    materiaisAcao: MateriaisAcao[];
    localExecucao: string;

    grupoAcao: GrupoAcoesSimples;
    statusAnalise: string;
    dataAnalise: Date;
    usuarioAnalise: UsuarioSistema;	

    // anexos: AnexosAcaoPlanejamento[] = [];
    // tamanhoMaximoAnexoExcedido?: boolean;

    recursosPedagogicos: string;
    qtdParticipantes: number;

    acoesExecutadas: AcaoExecutada[];
    metas: MetaAcao[];

}